import React, { Fragment, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import About from "./components/About/About";
import Certificates from "./components/Company/Certificates/Certificates";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import Memories from "./components/Memories/Memories";
import Album from "./components/Memories/Album";
import RememberingBobBelfi from "./components/Memories/RememberingBobBelfi/RememberingBobBelfi";
import CustomPaintJobs from "./components/Company/CustomPaint/CustomPaintJobs";
import TechTips from "./components/TechTips/TechTips";
import RecommendedTechs from "./components/RecommendedTechs/RecommendedTechs";
import "./index.css";
import './App.css';


const PAGE_TITLES = {
  "/": "Home | Rolling Thunder Cycles",
  "/about": "About | Rolling Thunder Cycles",
  "/apparel": "Apparel | Rolling Thunder Cycles",
  "/footpegs": "Footpegs | Rolling Thunder Cycles",
  "/certificates": "Certificates | Rolling Thunder Cycles",
  "/techtips": "Tech Tips | Rolling Thunder Cycles",
  "/contact": "Contact | Rolling Thunder Cycles",
  "/custom-paint-jobs": "Custom Paint Jobs | Rolling Thunder Cycles",
  "/remember-bob-belfi": "Remembering Bob Belfi | Rolling Thunder Cycles",
  "/memories": "Memories | Rolling Thunder Cycles",
  "/recommended-techs": "Recommended Techs | Rolling Thunder Cycles",
};

function TitleUpdater() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.toLowerCase();
    document.title = PAGE_TITLES[path] || "Rolling Thunder Cycles";
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <Router>
        <TitleUpdater />
        <Fragment>
          <Header />
          <main id="main">
            <section className="container-fluid">
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/about" element={<About />} />
                <Route exact path="/techtips" element={<TechTips />} />
                <Route exact path="/certificates" element={<Certificates />} />
                <Route exact path="/contact" element={<Contact />} />
                <Route exact path="/recommended-techs" element={<RecommendedTechs />} />
                <Route
                  exact
                  path="/custom-paint-jobs"
                  element={<CustomPaintJobs />}
                />
                <Route
                  exact
                  path="/remembering-bob-belfi"
                  element={<RememberingBobBelfi />}
                />
                <Route exact path="/memories" element={<Memories />} />
                <Route exact path="/memories/:albumName" element={<Album />} />
                {/* ...add more album routes as needed... */}
              </Routes>
            </section>
          </main>
          <Footer />
        </Fragment>
      </Router>
    </div>
  );
}

export default App;
